// Data-app color tokens (the HTML mock's CSS vars → hex). The app convention is hardcoded hex (no Tailwind
// theme tokens), so this is the shared palette for the Data detail pages that reference colors as JS values.
export const C = {
  t1: '#1A1C2E',
  t2: '#5C5F72',
  t3: '#9295A5',
  border: '#E4E0D8',
  blue: '#274483',
  warm: '#F5F6F8',
  pos: '#2A8055',
  neg: '#BC2E3D',
  warn: '#D27A24',
};

// `var(--…)` strings carried in the mock JSON → hex (superset across the Data pages).
export const VAR: Record<string, string> = {
  'var(--positive)': '#2A8055',
  'var(--negative)': '#BC2E3D',
  'var(--warning)': '#D27A24',
  'var(--blue-dark)': '#274483',
  'var(--blue-mid)': '#4A6BAD',
  'var(--blue-light)': '#91A2C0',
  'var(--text-1)': '#1A1C2E',
  'var(--text-2)': '#5C5F72',
  'var(--text-3)': '#9295A5',
  'var(--border)': '#E4E0D8',
  'var(--bg-warm)': '#F5F6F8',
  'var(--bg-white)': '#FFFFFF',
  '#8B5CF6': '#8B5CF6',
};
export const cv = (s: string) => VAR[s] || s;
